import React, {useEffect} from 'react'
import {connect} from 'react-redux'
import {useLocation} from 'react-router-dom'

import MenuType from 'enum/MenuType'
import CategoryType from 'enum/CategoryType'
import MyRouter from 'router/router'
import * as AppAction from 'store/app/action'
import * as css from './css/index'
import {observer} from 'mobx-react'
import Decoration from './partials/decoration/Decoration'
import Header from './partials/header/Header'
import Menu from './partials/menu/Menu'
import Content from './partials/content/Content'
import Footer from './partials/footer/Footer'
import RouterListener from './partials/router-listener/RouterListener'
// import TopAdvertisement from 'pages/home/partials/top-advertisement/TopAdvertisement'
import Service from 'components/service/Service'
import GoodsList from 'components/goods-list/GoodsList'
import LoginForm from 'components/login-form/LoginForm'
import useMyStores from "hooks/useMyStores";

function Index(props) {
    const {
        service,
        goodsList,
        login,
        user,
        menu,
        app,
        home
    } = useMyStores()

    const {
        appAction,
        appStore,
    } = props

    const location = useLocation()
    const {menuType} = appStore

    useEffect(() => {
        try {
            appAction.init()
            //初始化
            init()
            // 获取商品类别
            appAction.fetchGoodsCategoryList()

            /*
            * user
            *
            * 这里注释了，在user store 里面完成了这个功能 还没测试影响不
            * */
            // user.init();
            // if (user.isLogin) {
            //     user.fetchInfo();
            // }

            // if (userInfo.id !== 0) {
            //     user.setInfo({...userInfo, avatar: userInfo.avatarUrl})
            // }

            // 获取app信息
            app.fetchData()
        } catch (error) {
        }
    }, [])

    function init() {
        const {pathname} = location

        /**
         * 初始化首页
         */
        if (pathname === MyRouter.Home.path || pathname === MyRouter.Index.path) {
            home.canShowTopAdvertisement = true;
            home.showTopAdvertisement = true
        }

        /**
         * menu组件里面商品类别的变化
         */
        if (pathname.indexOf(MyRouter.News.realPath) !== -1) {
            appAction.setCategoryType(CategoryType.NEWS_CATEGORY.value)
        } else if (
            pathname === MyRouter.Home.path ||
            pathname === MyRouter.Index.path
        ) {
            appAction.setCategoryType(CategoryType.GOODS_CATEGORY.value)
        } else if (pathname === MyRouter.Search.path) {
            appAction.setCategoryType(CategoryType.SEARCH_GOODS_CATEGORY.value)
        } else {
            appAction.setCategoryType(CategoryType.NONE.value)
        }

        if (pathname.indexOf(MyRouter.Shop.path) !== -1) {
            appAction.setMenuType(MenuType.SHOP)
        } else if (
            pathname === MyRouter.SecKill.path ||
            pathname === MyRouter.User.path ||
            pathname === MyRouter.Cart.path ||
            pathname.indexOf(MyRouter.Merchant.path) !== -1 ||
            pathname === MyRouter.Help.path ||
            pathname === MyRouter.Order.path
        ) {
            appAction.setMenuType(MenuType.NONE)
        } else {
            appAction.setMenuType(MenuType.GOODS)
        }

        /**
         * menu的适应布局
         */
        if (pathname === MyRouter.Home.path || pathname === MyRouter.Index.path) {
            menu.is1200 = true
        } else {
            menu.is1200 = false
        }
    }

    return (
        // <Router basename={MyRouter.basename}>
        <css.Index className='index'>
            {/* <Suspense fallback={<Loading />}> */}
            <RouterListener/>

            {/* bg */}
            <div className='bg'></div>

            {/* top bg */}
            <div className='top-bg'>
                <img src={require('./img/top-bg.png')} alt='' className='img'/>
            </div>

            {/* center bg */}
            <img src={require('./img/center-bg.png')} alt='' className='center-bg'/>

            {/* bottom bg */}
            <div className='bottom-bg'>
                <img src={require('./img/bottom-bg.png')} alt='' className='img'/>
            </div>

            {/* decoration */}
            <css.Decoration as={Decoration}/>
            {/* top adv 暂时没有顶部广告了 */}
            {/*            {home.canShowTopAdvertisement && home.showTopAdvertisement && (
                <css.TopAdvertisement as={TopAdvertisement}/>
            )}*/}

            <css.Header as={Header}/>

            {/* logo 搜索 购物车 */}
            {menuType === MenuType.GOODS && <css.Menu as={Menu}/>}

            {/* {menuType === MenuType.SHOP && <css.ShopMenu as={ShopMenu} />} */}

            <css.Content className='page-content' as={Content}/>

            <css.Footer as={Footer}/>

            {/* service model */}

            {service.show && (
                <css.Model>
                    <css.Service as={Service}/>
                </css.Model>
            )}

            {/* goods list */}
            {goodsList.show && (
                <css.Model>
                    <css.GoodsList as={GoodsList}/>
                </css.Model>
            )}

            {/* login form */}
            {login.show && (
                <css.Model>
                    <css.LoginForm as={LoginForm}/>
                </css.Model>
            )}

            {/* </Suspense> */}
        </css.Index>
        // </Router>
    )
}

export default connect(
    (state) => {
        const {app} = state

        return {appStore: app}
    },
    (f) => ({
        appAction: {
            fetchGoodsCategoryList() {
                f(AppAction.fetchGoodsCategoryList(...arguments))
            },
            setCategoryType() {
                f(AppAction.setCategoryType(...arguments))
            },
            setMenuType() {
                f(AppAction.setMenuType(...arguments))
            },
            init() {
                f(AppAction.init(...arguments))
            },
        }
    })
)(
    (observer(Index))
)
